import { BaseError, ErrorChanel } from './base-error';

export class LoadTranslateError extends BaseError {
  public isLocalizationLoaded = false;
  public chanel: ErrorChanel = ErrorChanel.QA;
  public type = 'translate';
  public name = 'Localization load error';
  public error = 'Error to load translate';

  constructor() {
    super(`Error to load all translate list`);
  }
}
